module.exports = __webpack_public_path__ + "img/cred_cards.ca046a0c.png";